import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  constructor(private httpService: HttpService) { }

  getCountries(params: any): Observable<any[]> {
    return this.httpService.get("country", { params })
  }

  addOrUpdateCountry(payload: any) {
    return this.httpService.post('country', payload);
  }

  deleteCountry(id: number) {
    return this.httpService.delete(`country/${id}`);
  }
}
